import { useAppDispatch, useEffectOnce } from 'hooks'
import { ReactNode } from 'react'
import { getQueryParams } from 'utils'
import { InitData } from './components/InitData/InitData'
import { DEFAULT_TITLE_FONT_SIZE } from './Init.model'
import { setWidgetTitle, setWidgetTitleFontSize } from './state/Init.reducer'

export function InitProvider({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch()
  const { titleFontSize, title } = getQueryParams()

  useEffectOnce(() => {
    if (titleFontSize) {
      let fontSize = parseInt(titleFontSize, 10)
      if (isNaN(fontSize)) {
        fontSize = DEFAULT_TITLE_FONT_SIZE
      }
      dispatch(setWidgetTitleFontSize(fontSize))
    }

    if (title) {
      dispatch(setWidgetTitle(title))
    }
  })

  return <InitData>{children}</InitData>
}
